import { GET_JOBS_BY_PROPERTY } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case GET_JOBS_BY_PROPERTY.LOAD:
      return {
        ...state,
        loading: true,
      };
    case GET_JOBS_BY_PROPERTY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case GET_JOBS_BY_PROPERTY.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
